var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransitionExpand',[(_vm.visible)?_c('div',{key:'test',staticClass:"error"},[_c('small',[_vm._v(_vm._s(_vm.text))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }